import { create } from 'zustand';

interface SessionExpiredModalState {
  isOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
}

export const useSessionExpiredModalStore = create<SessionExpiredModalState>((set) => ({
  isOpen: false,
  openModal: () => set({ isOpen: true }),
  closeModal: () => set({ isOpen: false }),
}));

